export default __webpack_public_path__ + "static/media/Soulthunder Spangenhelm.67d0004d.jpg";